import { useState } from "react";
import { useSelector } from "react-redux";
import editIcon from "../../../../images/icons/edit.svg";
import deleteIcon from "../../../../images/icons/delete.svg";
import { Badge } from "react-bootstrap";
import { Translate } from "../../../Enums/Tranlate";
import ConfirmModal from "../../../common/ConfirmModal";
import DeleteModal from "../../../common/DeleteModal";
import VendorsService from "../../../../services/VendorsService";

const CardItem = ({ item, setAddModal, index, setItem, setShouldUpdate }) => {
	const [status, setStatus] = useState(item.status);
	const [statusModal, setStatusModal] = useState(false);
	const [deleteModal, setDeleteModal] = useState(false);
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.roles?.includes(data);
	const lang = useSelector((state) => state.auth?.lang);
	const vendorsService = new VendorsService();

	const changeStatus = () => {
		let data = {
			popular: !item?.popular,
		};
		vendorsService.update(item?.id, data).then((res) => {
			if (!!res?.status) {
				setStatus(!item?.status);
				setShouldUpdate((prev) => !prev);
				setStatusModal(false);
			}
		});
	};

	return (
		<tr key={index} className="text-center">
			<td>{item[`name_${lang}`] || "-"}</td>
			<td>{item?.email || "-"}</td>
			<td>{item?.contact || "-"}</td>
			<td>{item?.category[`name_${lang}`] || "-"}</td>
			<td>
				<div className="d-flex" style={{ gap: "20px" }}>
					{isExist("update_vender") && (
						<i className="la la-check accept-request" />
					)}
					{isExist("update_vender") && (
						<i className="la la-times reject-request" />
					)}
				</div>
			</td>
			{statusModal && (
				<ConfirmModal
					open={statusModal}
					title={item[`name_${lang}`]}
					body={
						lang === "en"
							? `are you sure about changing status for this Vendor?`
							: "هل أنت متأكد من تغيير الحالة لهذا البائع؟"
					}
					button={Translate[lang].submit}
					submitButton={changeStatus}
					onCloseModal={() => setStatusModal(false)}
				/>
			)}
			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={item[`name_${lang}`]}
					deletedItem={item}
					modelService={vendorsService}
					onCloseModal={setDeleteModal}
					setShouldUpdate={setShouldUpdate}
				/>
			)}
		</tr>
	);
};
export default CardItem;
